export { default as QAList } from "./QAList";
export { default as QAListItem } from "./QAListItem";



// WEBPACK FOOTER //
// ./src/core/admin/components/QA/components/index.js